<template>
  <div>

    <el-form ref="form" :model="submit_data" label-width="80px"
      style="overflow-y: auto; height: 85vh; margin-top: 20px;">




      <el-form-item label="表现分:" label-width='120px'>


        <span>{{ submit_data.monitor_point }}分</span>
        <el-button type="text" style="margin-left: 10px" @click="toDetails">查看详情</el-button>

      </el-form-item>

      <!-- <el-form-item label="销单分:" label-width='120px'>

        <span>{{ submit_data.refuse_point }}分</span>

      </el-form-item> -->

      <el-form-item label="星级分:" label-width='120px'>

        <span>{{ submit_data.star_point }}分</span>

      </el-form-item>

      <el-form-item label="活动积分:" label-width='120px'>

        <span>{{ submit_data.activity_point }}分</span>

      </el-form-item>

      <!-- <el-form-item label="优享分:" label-width='120px'>

        <span>{{ submit_data.priority_point }}分</span>

      </el-form-item> -->

<!--      <el-form-item label="小红花:" label-width='120px'>-->

<!--        <span>{{ submit_data.flowers_point }}</span>-->

<!--      </el-form-item>-->

<!--      <el-form-item label="小红花换分:" label-width='120px'>-->

<!--        <span>{{ flowers_point_change }}分</span>-->

<!--      </el-form-item>-->

      <el-form-item label="司机段位:" label-width='120px'>


        <span>{{ dan }}</span>

      </el-form-item>


      <el-form-item label="签约规则:" label-width='120px'>


        <span>{{ signing_type }}</span>

      </el-form-item>





      <el-form-item label="操作方式:" label-width='120px'>
        <el-radio-group v-model="submit_data_fraction.operation">
          <el-radio-button label="monitor_point">表现分</el-radio-button>
          <!-- <el-radio-button label="refuse_point">销单分</el-radio-button> -->
          <el-radio-button label="star_point">星级分</el-radio-button>
          <el-radio-button label="activity_point">活动积分</el-radio-button>
<!--          <el-radio-button label="flowers_point">小红花</el-radio-button>-->
        </el-radio-group>
      </el-form-item>

      <el-form-item label="模式:" label-width='120px'>
        <el-radio-group v-model="submit_data_fraction.mode">
          <el-radio-button label="add">+</el-radio-button>
          <el-radio-button label="sub">-</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="分数:" label-width='120px'>
        <el-input v-model="submit_data_fraction.points" :placeholder="submit_rules_fraction.points.placeholder"
          style="width: 100px;">
        </el-input>
      </el-form-item>

      <el-form-item label="描述:" label-width='120px'>
        <el-input type="textarea" v-model="submit_data_fraction.description" placeholder="对此加减分进行说明"
          style="width: 90%;">
        </el-input>
      </el-form-item>

      <el-form-item label="签约状态:" label-width='120px'>
        <p>{{ value_signing }}</p>
      </el-form-item>

      <el-form-item label="签约到期时间:" label-width='120px' v-if="this.submit_data.signing_status == '1'">
        <p>{{ time_arrway }}</p>
      </el-form-item>









      <div style="border: 1px solid #ccc;padding: 10px; border-radius: 5px;">



        <el-form-item label="优享券:" label-width='120px'>

          <span>{{ submit_data.priority_coupon }}张</span>

        </el-form-item>

        <el-form-item label="模式:" label-width='120px'>
          <el-radio-group v-model="monitor_point_data.mode">
            <el-radio-button label="add">+</el-radio-button>
            <el-radio-button label="sub">-</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="数量:" label-width='120px'>
          <el-input v-model="monitor_point_data.points" style="width: 100px;">
          </el-input>
        </el-form-item>

        <div style="text-align: center;">
          <el-button @click="monitorSubmit">确认修改优享券</el-button>
        </div>

      </div>






    </el-form>

    <div style="display: flex;justify-content: center">
      <el-button type="primary" @click="fractionSubmit">保存</el-button>
      <el-button @click="closeDialog">关闭</el-button>
    </div>


    <!-- 续费签约组件 -->
    <!-- <signing :data="driver_code_children" :signing_city_code="signing_city_code" :isShow="signing_isShow"
      @onSubmit="driverLists"></signing> -->

    <!--  查看详情组件  -->
    <detailsC :isShow="details_isShow" :data="submit_data_fraction.driver_code"></detailsC>

  </div>



</template>

<script>
  var _this;
  import bus from '../../common/bus.js';
  import detailsC from './driverFractionDetailsList';
  // import signing from 'signing';
  export default {
    props: {
      'driverShow': Boolean,
      'data': ''
    },
    components: {
      detailsC
    },
    watch: {
      driverShow: {
        immediate: true,
        handler: function (newData, oldData) {

          if (newData) {
            console.log(this.data);

            this.$post(
                "/driver/getDriverPointsDetails", {
                  driver_code: this.data
                }
              )
              .then(res => {

                if(res.data.signing_type == '0'){
                  this.signing_type = '按天签约'
                }else if(res.data.signing_type == '1'){
                  this.signing_type = '按月签约'
                }

                this.value_signing = res.data.signing_status.alias;

                if (res.data.signing_end_time.YmdHis !== "未设置") {
                  this.time_arrway = res.data.signing_end_time.YmdHis;
                }

                _this.dan = res.data.dan.alias

                this.submit_data.driver_code = res.data.driver_code;
                this.signingList = res.data.signing_status.select_array;

                // 请求的数据对应存入到submit_data对象中
                this.submit_data.driver_code = res.data.driver_code;
                this.submit_data_fraction.driver_code = res.data.driver_code;
                this.submit_data.star_point = res.data.star_point;
                this.submit_data.activity_point = res.data.activity_point;

                this.submit_data.monitor_point = res.data.monitor_point;


                this.submit_data.flowers_point = res.data.flowers_point;


                this.flowers_point_change = res.data.flowers_point_change;

                this.submit_data.signing_status = res.data.signing_status.val;

                this.submit_data.signing_end_time_stamp = res.data.signing_end_time_stamp;
                this.submit_data.priority_coupon = res.data.priority_coupon;



              })
          }



        }

      },

    },
    data() {
      return {
        details_isShow:false,
        value_signing: '',

        signing_type:'',

        dan:'',

        flowers_point_change: '',

        monitor_point_data: {
          mode: 'add',
          points: ''
        },


        // 表单提交数据
        submit_data_fraction: {
          driver_code: '',
          mode: 'add',
          operation: '',
          points: ''
        },

        submit_rules_fraction: {
          mode: {
            placeholder: '模式',
            rules: {
              required: true,
              message: '未选择模式',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          operation: {
            placeholder: '操作方式',
            rules: {
              required: true,
              message: '未选择操作方式',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          points: {
            placeholder: '请输入分数',
            rules: {
              required: true,
              message: '金额需为1-999999的数字',
              regulation: 'egt',
              rulesData: 0
            }
          }
        },


        // 表单数据
        submit_data: {

          driver_code: '',
          star_point: '',
          activity_point: '',
          // priority_point: '',
          monitor_point: '',
          // refuse_point: '',
          signing_status: '',
          signing_end_time: '',
          priority_coupon: '',
          flowers_point: '',
          description: ''

        },


      };
    },
    created() {

      _this = this;



    },
    methods: {
      //查看详情
      toDetails(){

        _this.details_isShow = ! _this.details_isShow

      },

      getDriverPoints() {
        this.$post(
            "/driver/getDriverPointsDetails", {
              driver_code: this.data
            }
          )
          .then(res => {
            console.log(res.data);
            console.log(res.data.signing_end_time.YmdHis);

            this.value_signing = res.data.signing_status.alias;

            if (res.data.signing_end_time.YmdHis !== "未设置") {
              this.time_arrway = res.data.signing_end_time.YmdHis;
            }


            this.submit_data.driver_code = res.data.driver_code;
            this.signingList = res.data.signing_status.select_array

            // 请求的数据对应存入到submit_data对象中
            this.submit_data.driver_code = res.data.driver_code;
            this.submit_data.star_point = res.data.star_point;
            this.submit_data.activity_point = res.data.activity_point;
            // this.submit_data.priority_point = res.data.priority_point;
            this.submit_data.monitor_point = res.data.monitor_point;
            // this.submit_data.refuse_point = res.data.refuse_point;
            this.submit_data.flowers_point = res.data.flowers_point;
            this.flowers_point_change = res.data.flowers_point_change;
            this.submit_data.signing_status = res.data.signing_status.val;

            this.submit_data.signing_end_time_stamp = res.data.signing_end_time_stamp;
            this.submit_data.priority_coupon = res.data.priority_coupon;


            this.submit_data.monitor_point = res.data.monitor_point;



          })
      },

      monitorSubmit() {

        console.log(111);

        _this.$post(
          "/driver/editDriverPriorityCouponSubmit", {
            driver_code: this.data,
            num: _this.monitor_point_data.points,
            mode: _this.monitor_point_data.mode
          }
        ).then(res => {

          _this.$message.success(res.msg)

          _this.getDriverPoints();


        }).catch((err) => {

        })

      },


      // 修改分数按钮
      fractionSubmit() {
        _this.$post(
            "/driver/editDriverPointsSubmit",
            _this.submit_data_fraction,
            _this.submit_rules_fraction
          )
          .then(res => {

            _this.$message.success({
              message: res.msg,
              duration: 1500
            });

            _this.getDriverPoints()
          }).catch(res => {

          })
      },


      // 关闭方法
      closeDialog() {

        for (const key in this.submit_data_fraction) {
          this.submit_data_fraction[key] = '';
        }

        _this.monitor_point_data = {
          mode: 'add',
          points: ''
        }

        _this.dan = '';
        _this.flowers_point_change = '';
        _this.$emit('closeDialog');

      },



    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }

  .btn-fraction {
    padding: 5px;
  }
</style>
